/**
 * Exclusión de empresas de los "Modales Especiales" de AdvocatesPro: los
 * modales de novedades, webinars y convocatorias con los que se comunica la
 * nueva versión (v3) a los admins que todavía están en v2.
 *
 * La lista vivía dentro de `advproAmbassadorWebinar.constants.ts` cuando la
 * exclusión aplicaba a un solo modal (ADV-3170). Al extenderse a toda la
 * familia se extrajo acá para tener UN solo lugar donde agregar o sacar
 * empresas: cada modal nuevo solo tiene que llamar a
 * `isExcludedFromSpecialModals()` en su `shouldShow...`.
 */

import { getCurrentCompany } from 'helpers/companyHelper';

/**
 * Empresas que NO ven ningún Modal Especial, aunque su admin cumpla el resto de
 * las condiciones. Se identifican por subdominio, en minúsculas.
 *
 * Pedido de negocio: MINEROS (company id 107 en base de datos) queda fuera de
 * estas comunicaciones. Se filtra por subdominio y no por id porque
 * `getCurrentCompany()` es síncrono —sale del hostname— y no depende de que el
 * usuario ya haya cargado: filtrar por `companyId` deja una ventana en la que
 * el modal alcanza a renderizarse mientras llega el payload.
 */
export const MODAL_EXCLUDED_SUBDOMAINS = ['mineros'];

/**
 * True si la empresa del subdominio actual está excluida de los Modales
 * Especiales.
 *
 * El subdominio sale de `getCurrentCompany()`, que lo lee del hostname. Fuera de
 * `*.advocatespro.com` (local, QA) devuelve un valor fijo de ambiente que nunca
 * matchea la lista, así que la exclusión es un no-op y los modales se pueden
 * probar normalmente.
 */
export const isExcludedFromSpecialModals = (): boolean => {
  try {
    return MODAL_EXCLUDED_SUBDOMAINS.includes(
      getCurrentCompany().toLowerCase()
    );
  } catch {
    // Sin `window` (SSR, tests) no hay subdominio que evaluar: no excluye.
    return false;
  }
};
